export const hidePlayer = (container) => {
  if (container) {
    container?.scrollTo(0, 0);
    container?.classList?.add('invisible');
  }
};

export const showPlayer = (container) => {
  if (container) {
    container?.classList?.remove('invisible');
  }
};

export const showLoading = (container, loadingIndicator, cbPlayer) => {
  if (container && loadingIndicator && cbPlayer) {
    container?.classList?.remove('overflow-auto');
    container?.classList?.add('overflow-hidden');
    loadingIndicator?.classList?.remove('invisible');
    cbPlayer?.classList?.add('invisible');
  } else {
    container?.classList?.remove('invisible');
  }
};

export const hideLoading = (container, loadingIndicator, cbPlayer) => {
  if (container && loadingIndicator && cbPlayer) {
    container?.classList?.remove('overflow-hidden');
    container?.classList?.add('overflow-auto');
    loadingIndicator?.classList?.add('invisible');
    cbPlayer?.classList?.remove('invisible');
  }
};

export const hideFirstPlayerItem = (container, reference, uuid) => {
  const item = container?.querySelector(`div[data-reference="${reference}"]`);
  if (item) {
    item.style = null;
    item.classList.add('is-invisible');
    item.dataset.reference = `${reference}---${uuid.getNameSpace()}`;
  }
};

export const hideQuestionEl = (container, reference, uuid) => {
  const item = container?.querySelector(
    `div[data-reference="${reference}---${uuid.getNameSpace()}"]`,
  );
  if (item) {
    item.style = null;
    item.classList.add('is-invisible');
    item.classList.remove('is-visible');
  }
};
